<template>
  <div class="goods-list-div">
    <div v-for="(group_item, group_index) in groupList" :key="group_index">
      <div class="goods-list-title d_jump">
        {{ group_item.cateName }}
      </div>
      <div
        class="goods-detail-list-div"
        v-for="(goods_item, goods_index) in group_item.goodsDTOS"
        :key="goods_index"
      >
        <van-row>
          <van-col span="10">
            <!-- <van-badge color="#ff0000" :content="goods_item.count"> -->
            <div class="goods-image-div">
              <!-- <van-badge color="#ff0000" content="3"> -->
              <img class="goods-image" :src="goods_item.thumb" loading="lazy" />
              <!-- </van-badge> -->
            </div>
          </van-col>
          <van-col span="14">
            <div class="goods-details-div">
              <div class="goods-name">{{ goods_item.name }}</div>
              <div class="goods-tag">
                <van-tag plain round text-color="#2e6c45"
                  >已省{{
                    parseFloat(
                      goods_item.officialPrice - goods_item.price
                    ).toFixed(2)
                  }}元</van-tag
                >
              </div>

              <van-row>
                <van-col span="8">
                  <div class="price-div">
                    <span>¥</span>
                    <span>{{ goods_item.price }}</span>
                  </div>
                </van-col>
                <van-col span="6">
                  <div class="old-price-div">
                    <span>¥{{ goods_item.officialPrice }}</span>
                  </div>
                </van-col>
                <van-col span="10">
                  <div class="add-goods-div">
                    <!-- <van-icon  @click="changeGoods(goods_item.goodsId)" name="add" color="#2e6c43"/> -->
                    <!-- <van-badge v-if="goods_item.count>0" color="#ff0000" :content="goods_item.count"> -->
                    <van-badge
                      color="#ff0000"
                      :content="getCountById(goods_item.goodsId)"
                    >
                      <van-button
                        round
                        color="#2e6c43"
                        @click="changeGoods(goods_item)"
                        >选规格</van-button
                      >
                    </van-badge>
                    <!-- <div v-if="false" class="select-count">
										    <van-stepper min="0" theme="round" disable-input />
										</div> -->
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="emtry-div"></div>
  </div>
</template>

<script>
	import { goodsListSelect,goodsSpecSelect,addShopCar } from '@/request/api';
	import {Col, Row,Tag,Button ,Icon,Badge,Stepper} from 'vant';
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'ComGoodsList',
		computed: mapGetters(["getCountById","sShop"]),
		components: {
		      [Col.name]: Col,
		      [Row.name]: Row,
		      [Tag.name]: Tag,
		      [Button.name]: Button,
		      [Stepper.name]: Stepper,
		      [Icon.name]: Icon,
		      [Badge.name]: Badge
		 },
		created: function() {
		     this.selectGoodsList();
	    },
		data(){
			return {
				groupList:[],
				goodsSpec:{}
				
			}
		},
		methods:{
			...mapMutations(['addNoSpecGoods']),
			showSpecModel(){
				this.$emit('changeSpecModel',true);
			},
			selectGoodsList(){
				goodsListSelect({
					storeId:this.sShop.storeId
				}).then(res => {
					// 字段处理
					// console.log(res)
					res.forEach(item =>{
						if(item.id){
							item.cateId = item.id;
							item.cateName = item.name;
							item.goodsDTOS = item.productList;
							item.goodsDTOS.forEach(childItem =>{
								childItem.goodsId = childItem.foodid;
								childItem.name = childItem.foodname;
								childItem.officialPrice = childItem.medium_cup_xty==9999?(childItem.big_cup_xty==9999?(childItem.oversized_cup_original):(childItem.big_cup_original)):childItem.medium_cup_original;
								childItem.price = childItem.medium_cup_xty==9999?childItem.big_cup_xty==9999?(childItem.oversized_cup):childItem.big_cup:childItem.medium_cup;
								childItem.cateId = item.id;
								childItem.hcPrice = childItem.medium_cup_xty==9999?(childItem.big_cup_xty==9999?(childItem.oversized_cup_xty):(childItem.big_cup_xty)):childItem.medium_cup_xty;
								childItem.thumb = childItem.foodimg;
								
							})
						}
						
					})
					this.groupList = res;							  
				})  
			},
			changeGoods(goods_item){
				console.log(goods_item,'商品信息')
				let res = {
					id:goods_item.goodsId,
					name:goods_item.name,
					price:goods_item.price, // 售价
					hcPrice:goods_item.hcPrice, // 供货价
					officialPrice:goods_item.officialPrice, // 原价
					thumb:goods_item.thumb,
					specItemDTOS:[]
				};
				// 
				if(goods_item.type && goods_item.type != 0){
					let spcArr = [];
					if(goods_item.type.includes('中杯')){
						goods_item.type.split(',').forEach((item,index)	 =>{
							spcArr.push({
								"itemId": index, 
								"itemName": item, 
								"upPrice": item == "中杯"?0:(item == "大杯"?3:6),
								"checked": index == 0?1:null
							})
						})
					}else if(goods_item.type.includes('大杯')){
						goods_item.type.split(',').forEach((item,index)	 =>{
							spcArr.push({
								"itemId": index, 
								"itemName": item, 
								"upPrice": item == '大杯'?0:3,
								"checked": index == 0?1:null
							})
						})
					}else{
						goods_item.type.split(',').forEach((item,index)	 =>{
							spcArr.push({
								"itemId": index, 
								"itemName": item, 
								"upPrice": 0,
								"checked": index == 0?1:null
							})
						})
					}
					res.specItemDTOS.push({
						  "specId": 1, 
						  "specName": "杯型", 
						  itemDTOS:spcArr
					})
				}
				
				if(goods_item.temperature && goods_item.temperature != 0){
					let spcArr = [];
					goods_item.temperature.split(',').forEach((item,index)	 =>{
						spcArr.push({
							"itemId": index, 
							"itemName": item, 
							"upPrice": 0, 
							"checked": index == 0?1:null
						})
					})
					res.specItemDTOS.push({
						  "specId":2, 
						  "specName": "温度", 
						  itemDTOS:spcArr
					})
				}
				if(goods_item.concentrate && goods_item.concentrate != 0){
					let spcArr = [];
					goods_item.concentrate.split(',').forEach((item,index) =>{
						spcArr.push({
							"itemId": index, 
							"itemName": item, 
							"upPrice": 0, 
							"checked": index == 0?1:null
						})
					})
					res.specItemDTOS.push({
						  "specId":3, 
						  "specName": "类型", 
						  itemDTOS:spcArr
					})
				}
				if(goods_item.add && goods_item.add != 0){
					let spcArr = [];
					goods_item.add.split(',').forEach((item,index)	 =>{
						spcArr.push({
							"itemId": index, 
							"itemName": item, 
							"upPrice": 0, 
							"checked": index == 0?1:null
						})
					})
					res.specItemDTOS.push({
						  "specId":4, 
						  "specName": "口味", 
						  itemDTOS:spcArr
					})
				}
				
				// console.log(res)
				this.$emit('getGoodsSpec',res)
				// return;
				// this.$emit('getGoodsSpec',res)
				
				//查询商品规格
				// goodsSpecSelect({
				// 	goodsId:goods_item.goodsId		  
				// }).then(res => {
				// 	if(res){
				// 		this.$emit('getGoodsSpec',res)
				// 	}else{
				// 		this.addNoSpec(goods_item);
				// 	}
					
				    
				// }) 
				
				
				
				
			},
			// addNoSpec(goods_item){
			// 	//新增接口
			// 	let params = {};
			// 	params.location = this.sShop.lonAndLat;
			// 	params.shopName = this.sShop.shopName;
			// 	// params.goodsId = goods_item.goodsId;
			// 	params.goodsId = goods_item.goodsId;
			// 	params.goodsNum = 1;
			// 	params.yuedongShoppingDetailVOS = [];
			// 	addShopCar(params).then(res => {
			// 		goods_item.id = res;
			// 		this.addNoSpecGoods(goods_item);
			// 	});
			// }
		}
	}
</script>

<style scoped>
.goods-list-title {
  font-size: 15px;
  line-height: 18px;
  font-weight: 600;
  color: #363636;
}
.goods-detail-list-div {
  padding-top: 15px;
}
.goods-detail-list-div > div {
  background-color: #ffffff;
}
.goods-image-div {
  padding-top: 15px;
  text-align: center;
}
.goods-image {
  width: 70px;
  height: 70px;
}
.goods-name {
  font-size: 16px;
  line-height: 20px;
  font-weight: 650;
  color: #363636;
}
.goods-details-div {
  padding-top: 18px;
}

.goods-tag {
  margin-top: 8px;
}

.goods-tag > .van-tag {
  font-size: 11px;
  padding: 2px 8px;
}
.goods-tag > .van-tag.van-tag--plain::before {
  border-color: #63c990;
}

.price-div {
  padding-top: 5px;
  padding-left: 5px;
}
.price-div > span:first-child {
  font-size: 14px;
  color: #d24249;
  font-weight: 600;
}
.price-div > span:last-child {
  font-size: 18px;
  color: #d24249;
  font-weight: 600;
}
.old-price-div {
  padding-top: 10px;
  font-size: 13px;
  text-decoration: line-through;
  color: #909292;
  padding-left: 5px;
}
.add-goods-div {
  text-align: center;
}
.add-goods-div .van-badge__wrapper {
  float: right;
  margin-right: 4px;
}

.add-goods-div .van-icon {
  font-size: 23px;
}

.add-goods-div .van-button {
  margin: 0 auto;
  height: 25px;
  min-width: 55px;
  font-size: 12px;
  padding: 2px;
  font-weight: 500;
}
.emtry-div {
  width: 100%;
  height: 80px;
}

.select-count {
  margin-left: 15px;
}

.select-count button:first-child {
  width: 20px;
  height: 20px;
  color: #2e6c43;
  border-color: #2e6c43;
}
.select-count button:last-child {
  width: 20px;
  height: 20px;
  background-color: #2e6c43;
  border-color: #2e6c43;
}

/* .goods-detail-list-div /deep/ .van-badge--fixed {
		top:unset;
		bottom:-8px;
		right: 2px;
		background-color: #65db79 !important;
	} */
</style>
